"use server";

/**
 * Server actions compartidas del back-office: bandeja de notificaciones
 * (SOS / salida segura / mensaje flaggeado) visible en el dashboard.
 * Patrón canónico: requireRole → getDb → SERVICIO de dominio.
 */
import { getDb } from "@/db/client";
import { markAllRead, markRead } from "@/db/domains/notifications/notifications.service";
import { requireRole } from "@/lib/auth/server";
import type { Locale } from "@/lib/mock";

export async function markNotificationReadAction(input: {
  locale: Locale;
  notificationId: string;
}): Promise<{ ok: boolean }> {
  const user = await requireRole("admin", input.locale);
  const db = await getDb();
  await markRead(db, input.notificationId, user.userId);
  return { ok: true };
}

export async function markAllNotificationsReadAction(input: {
  locale: Locale;
}): Promise<{ ok: boolean }> {
  const user = await requireRole("admin", input.locale);
  const db = await getDb();
  await markAllRead(db, user.userId);
  return { ok: true };
}
